import type { UnionTypeLibelle } from '../../../techniques'
import type { SousDispositif } from './SousDispositif'

export const TypeQualification = [
  'Rncp',
  'Cqp',
  'ClassificationsCcn',
  'CproExperimental', // Non prise en chareg
  'ValidationDesAcquisExperience', // Non prise en charge
] as const

export type TypeQualification = (typeof TypeQualification)[number]

export const TypeQualificationLibelle: UnionTypeLibelle<TypeQualification> = {
  Rncp: '1 - Certification enregistrée au RNCP autre qu’un CQP',
  Cqp: '2 - Certificat de qualification professionnelle (CQP)',
  ClassificationsCcn: '3 - Qualification reconnue dans les classifications d’une convention collective nationale',
  CproExperimental:
    '4 - Action délivrée dans le cadre du contrat de professionnalisation expérimental prévu en application du VI de l’article 28 de la loi n° 2018-771 du 5 septembre 2018',
  ValidationDesAcquisExperience:
    "8 - Certification ou qualification professionnelle visée dans le cadre de l’expérimentation associant des actions de validation des acquis de l'expérience mentionnée à l'article 11 de la loi n° 2022-1598 du 21 décembre 2022",
} as const

export const TypeQualificationSousDispositif: { [key in SousDispositif]?: TypeQualification[] } = {
  ContratProfessionnalisation: ['Rncp', 'Cqp', 'ClassificationsCcn'],
  ContratProfessionnalisationHope: ['Rncp', 'Cqp', 'ClassificationsCcn'],
  ContratProfessionnalisationExperimental: ['Rncp', 'Cqp', 'ClassificationsCcn'],
  Prodiat: ['ClassificationsCcn'],
}
